export const FIX_SIZE = 'FIX_SIZE';
export const FULL_SIZE = 'FULL_SIZE';
